import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import EmailForm from "../EmailForm";
import Footer from "components/_core/Footer";
import Seo from "components/Seo";
import GivingBanner from "components/GivingBanner";
import Button, { ButtonA } from "components/_core/Button";
import { SubscribeBtn } from "components/buttons";
import { GridItem, ThreeGrid } from "components/_core/grids";
import { Testimonial as T } from "components/Home/TestimonialGrid";
import { Modal, ModalWrapper, ModalBody } from "components/_core/Modal";

import emailLogo from "img/summer-reading-challenge/header.png";
import heroImg from "img/summer-reading-challenge/hero.png";
import appStoreBadge from "img/summer-reading-challenge/app-store.svg";
import googlePlayBadge from "img/summer-reading-challenge/google-play.png";

const Page = styled.div`
    background-color: #fffdf4;
    overflow: hidden;
`;

const LogoWrap = styled.div`
    text-align: center;
    padding: 30px 15px 10px;
`;

const Logo = styled.img`
    width: 320px;
    max-width: 80%;
    display: inline-block;
`;

const HeroWrap = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 10px 15px 0;
`;

const Hero = styled.img`
    width: 100%;
    display: block;
    height: auto;
    border-radius: 12px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
`;

const Wrapper = styled.div`
    max-width: 960px;
    margin: 0 auto;
    padding: 0 24px;
`;

const NarrowWrapper = styled(Wrapper)`
    max-width: 720px;
`;

const SectionTitle = styled.h2`
    font-size: 2.6rem;
    font-weight: 900;
    line-height: 1.15;
    text-align: center;
    margin: 40px 0 24px;
    color: #1d4d2b;

    @media screen and (max-width: 700px) {
        font-size: 2rem;
    }
`;

const Lede = styled.p`
    font-size: 1.15rem;
    line-height: 1.6;
    margin: 0 0 18px;
    color: #222;
`;

const Body = styled.div`
    p {
        font-size: 1.05rem;
        line-height: 1.6;
        margin: 0 0 16px;
        color: #222;
    }

    ol,
    ul {
        font-size: 1.05rem;
        line-height: 1.6;
        margin: 0 0 16px;
        padding-left: 22px;
        color: #222;
    }

    li {
        margin-bottom: 8px;
    }

    a {
        color: ${props => props.theme.colors.teal};
        text-decoration: underline;
    }
`;

const SubHeading = styled.h3`
    font-size: 1.5rem;
    font-weight: 800;
    margin: 28px 0 12px;
    color: #1d4d2b;
`;

const TestimonialsWrap = styled.div`
    background: linear-gradient(180deg, #a8e4bd 0%, #8ce18c 100%);
    padding: 50px 24px;
    margin: 50px 0;
    border-radius: 18px;
    box-shadow: 0 12px 30px rgba(29, 77, 43, 0.18);
`;

const TestimonialsHeading = styled.h3`
    text-align: center;
    font-size: 1.5rem;
    font-weight: 800;
    color: #1d4d2b;
    margin: 0 0 30px;
`;

const TestiGrid = styled(ThreeGrid)`
    max-width: 1000px;
    margin: 0 auto;
`;

const Testimonial = styled(T)`
    background-color: #fff;
    border-radius: 12px;
    padding: 22px 22px 18px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
    height: 100%;
    box-sizing: border-box;

    p {
        font-size: 1rem;
        line-height: 1.5;
    }

    .highlight {
        background-color: #fefb41;
        padding: 1px 2px;
    }

    .teal {
        margin-top: 12px;
        color: #1d4d2b;
        font-weight: 700;
    }
`;

const ImportantBox = styled.div`
    background-color: #fff;
    border: 2px dashed #1d4d2b;
    border-radius: 12px;
    padding: 22px 26px;
    margin: 24px 0;

    h3 {
        margin-top: 0;
    }

    ul {
        margin-bottom: 0;
    }
`;

const CatchBox = styled.div`
    background-color: #ff7a57;
    color: #fff;
    border-radius: 14px;
    padding: 30px 32px;
    margin: 40px 0;
    box-shadow: 0 10px 24px rgba(255, 122, 87, 0.3);

    h3 {
        color: #fff;
        margin: 0 0 12px;
        font-size: 1.6rem;
    }

    p {
        margin: 0 0 12px;
        font-size: 1.05rem;
        line-height: 1.6;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

const CatchCTAWrap = styled.div`
    text-align: center;
    margin-top: 18px;
`;

const CatchCTA = styled(SubscribeBtn)`
    text-transform: none;
    padding: 14px 32px;
    font-size: 17px;
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000033;
    background-color: #1a1a1a;
    color: #fff;

    &:hover:not(:disabled) {
        background-color: #000;
    }
`;

const PromoCode = styled.strong`
    background-color: #fefb41;
    color: #1d4d2b;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 800;
    letter-spacing: 1px;
`;

const Highlight = styled.span`
    background-color: #fefb41;
    padding: 1px 2px;
`;

const SignupWrap = styled.div`
    background-color: #fff;
    border-radius: 18px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    padding: 32px 24px 28px;
    margin: 30px 0;
    text-align: center;
`;

const SignupTitle = styled.h3`
    margin: 0 0 6px;
    font-size: 1.6rem;
    font-weight: 800;
    color: #1d4d2b;
`;

const SignupSub = styled.p`
    margin: 0 0 18px;
    color: #555;
    font-size: 1rem;
`;

const SmsButton = styled(ButtonA)`
    text-transform: none;
    padding: 16px 28px;
    width: 100%;
    max-width: 325px;
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000021;
    margin: 6px auto 4px;
    font-size: 17px;
    font-weight: bold;
    background-color: ${props => props.theme.colors.teal};
    color: #fff;
    border-radius: 32px;
    display: inline-block;

    &:hover {
        background-color: #52c4c5;
    }
`;

const OrDivider = styled.div`
    margin: 18px auto 12px;
    font-weight: bold;
    color: #999;
    font-size: 13px;
    letter-spacing: 2px;

    display: flex;
    align-items: center;
    max-width: 325px;
    gap: 10px;

    &::before,
    &::after {
        content: "";
        flex: 1;
        height: 1px;
        background-color: #ddd;
    }
`;

const StoreSection = styled.div`
    background-color: #1d4d2b;
    color: #fff;
    padding: 40px 24px;
    margin: 30px 0 0;
    border-radius: 18px;
    text-align: center;
`;

const StoreHeading = styled.h3`
    margin: 0 0 6px;
    font-size: 1.5rem;
    font-weight: 800;
`;

const StoreSub = styled.p`
    margin: 0 0 22px;
    color: #cfe8d3;
    font-size: 1rem;
`;

const StoreBadges = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
`;

const StoreLink = styled.a`
    display: inline-block;
    line-height: 0;
    transition: transform 0.15s ease;

    &:hover {
        transform: translateY(-2px);
    }
`;

const AppStoreBadge = styled.img`
    height: 56px;
    width: auto;
    display: block;
`;

const GooglePlayBadge = styled.img`
    height: 56px;
    width: auto;
    display: block;
`;

const DateBanner = styled.div`
    text-align: center;
    padding: 50px 24px 60px;

    h2 {
        font-size: 2.4rem;
        font-weight: 900;
        margin: 0;
        line-height: 1.2;
        color: #1d4d2b;
    }

    @media screen and (max-width: 700px) {
        h2 {
            font-size: 1.8rem;
        }
    }
`;

const SuccessModalWrapper = styled(ModalWrapper)`
    max-width: 480px;
    min-height: 0;
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const SuccessModalBody = styled(ModalBody)`
    text-align: center;
    padding: 40px 32px 32px;
    background-color: #fffdf4;

    h2 {
        color: #1d4d2b;
        font-size: 1.8rem;
        font-weight: 900;
        margin: 0 0 12px;
    }

    p {
        color: #222;
        font-size: 1.1rem;
        line-height: 1.5;
        margin: 0 0 24px;
    }
`;

const SuccessCTA = styled(Button)`
    text-transform: none;
    padding: 14px 32px;
    font-size: 17px;
    border: 2px solid #fff;
    box-shadow: 0px 6px 0 0 #00000021;
`;

const RHYTHMBOT_URL = "https://rhythmbot.jpbouvetmethod.com";

const SummerReadingChallenge = () => {
    const [signupComplete, setSignupComplete] = useState(false);

    const goToRhythmBot = () => {
        window.location.href = "https://rhythmbot.jpbouvetmethod.com";
    };

    return (
        <Page>
            <Seo
                title="Summer Reading Challenge"
                description="Join the JP Bouvet Summer Reading Challenge — read On Drumming, work through the ideas behind improvisation, and get free drumming resources along the way." />
            <GivingBanner />

            <LogoWrap>
                <Link to="/">
                    <Logo src={emailLogo} alt="JP Bouvet Method" />
                </Link>
            </LogoWrap>

            <HeroWrap>
                <Hero src={heroImg} alt="Summer Reading Challenge (Triplet Edition) with RhythmBot" />
            </HeroWrap>

            <Wrapper>
                <SectionTitle>Master Triplet Rhythms in 50 Days</SectionTitle>
            </Wrapper>

            <NarrowWrapper>
                <Body>
                    <Lede>Happy summer! Those who were here last summer will remember we did the 80-Day Summer Reading Challenge in <em>straight time.</em></Lede>
                    <Lede>This summer, in keeping with our &ldquo;Year-of-Triplets,&rdquo; we are doing the <strong>50-Day Triplet Summer Reading Challenge!</strong></Lede>
                    <Lede>Gang, this is <strong>FREE</strong>, <strong>FUN</strong>, and <strong>TRANSFORMATIVE</strong>. As your teacher, I strongly encourage you to participate.</Lede>
                </Body>
            </NarrowWrapper>

            <Wrapper style={{ maxWidth: '1100px' }}>
                <TestimonialsWrap>
                    <TestimonialsHeading>What students said last year</TestimonialsHeading>
                    <TestiGrid stackPoint="600px">
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;I can now <span className="highlight">easily read any chart</span> placed in front of me.&rdquo;</p>
                                <p className="teal">&mdash; Joe</p>
                            </Testimonial>
                        </GridItem>
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;It&rsquo;s absolutely amazing that I can look at ANYTHING the RhythmBot throws at me and be able to <span className="highlight">instantly sing it</span>.&rdquo;</p>
                                <p className="teal">&mdash; Maulin</p>
                            </Testimonial>
                        </GridItem>
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;<span className="highlight">Massive transformation</span> &mdash; I can now sight-read and record the rhythms in my head.&rdquo;</p>
                                <p className="teal">&mdash; Matthew</p>
                            </Testimonial>
                        </GridItem>
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;Even with my full time job and other activities, I was able to <span className="highlight">keep up with the course</span> and sharpen my skills.&rdquo;</p>
                                <p className="teal">&mdash; Troy</p>
                            </Testimonial>
                        </GridItem>
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;You&rsquo;ll <span className="highlight">definitely be a better drummer</span> afterwards.&rdquo;</p>
                                <p className="teal">&mdash; DeShawndre</p>
                            </Testimonial>
                        </GridItem>
                        <GridItem>
                            <Testimonial>
                                <p>&ldquo;Whether you could read music or not, this challenge <span className="highlight">drastically improves your reading skills.</span>&rdquo;</p>
                                <p className="teal">&mdash; Eric</p>
                            </Testimonial>
                        </GridItem>
                    </TestiGrid>
                </TestimonialsWrap>
            </Wrapper>

            <NarrowWrapper>
                <Body>
                    <SubHeading>Here&rsquo;s how it works</SubHeading>
                    <p>Over the course of 50 days, you&rsquo;ll gradually build your sight-reading, rhythmic theory, and creativity using RhythmBot, an app for drummers that a student and I made. Each day introduces a small step, which all add up in the end.</p>

                    <SubHeading>How long does it take?</SubHeading>
                    <p>It takes 6 minutes per day, divided into two parts:</p>
                    <ol>
                        <li><strong>Watch and play along (3 minutes):</strong> Follow a short video lesson where I guide you through the new rhythms of the day.</li>
                        <li><strong>Practice on your own (3 minutes):</strong> Use the <a href={RHYTHMBOT_URL} target="_blank" rel="noopener noreferrer">RhythmBot app</a> on your phone to reinforce what you learned.</li>
                    </ol>

                    <SubHeading>How do I join?</SubHeading>
                    <p>Because this is a daily challenge, it&rsquo;s important to build it into your routine. To help you stay consistent, sign up for email and/or SMS reminders. Every day, you&rsquo;ll get a message with:</p>
                    <ul>
                        <li><strong>Link 1:</strong> A link to the 3-minute practice video with me (JP).</li>
                        <li><strong>Link 2:</strong> A link that opens your RhythmBot app with the day&rsquo;s presets already loaded.</li>
                    </ul>

                    <ImportantBox>
                        <SubHeading>Important stuff</SubHeading>
                        <ul>
                            <li><Highlight>The only way to participate</Highlight> in this challenge is to sign up below.</li>
                            <li><Highlight>To receive the links via SMS</Highlight>, click the SMS button and enter your phone number (US only). You will not receive any other marketing materials.</li>
                            <li><Highlight>To receive the links via email</Highlight>, simply enter your email below.</li>
                        </ul>
                    </ImportantBox>

                    <CatchBox>
                        <h3>Do I need to be a JPBMethod subscriber?</h3>
                        <p>The daily practice links that load RhythmBot presets will work for everyone. However, a JPBouvetMethod.com subscription is required to access the daily &ldquo;Practice with JP&rdquo; videos. These are optional, but are recommended for getting the most out of the challenge.</p>
                        <p>Use the code <PromoCode>SRC</PromoCode> to get 50% off your first month.</p>
                        <CatchCTAWrap>
                            <CatchCTA pill large>Sign Up Now</CatchCTA>
                        </CatchCTAWrap>
                    </CatchBox>
                </Body>

                <SignupWrap>
                    <SignupTitle>Sign up to participate</SignupTitle>
                    <SignupSub>Pick your preferred way to get the daily links.</SignupSub>

                    <SmsButton
                        href="https://mailchi.mp/134b976c5b7f/sms-signup"
                        target="_blank"
                        rel="noopener noreferrer"
                        bold
                        pill
                        large
                    >
                        Get SMS Notifications
                    </SmsButton>

                    <OrDivider>OR</OrDivider>

                    <EmailForm
                        tags="3404432"
                        buttonText="Get Email Notifications"
                        onSuccess={() => setSignupComplete(true)}
                    />
                </SignupWrap>

                <StoreSection>
                    <StoreHeading>Get the RhythmBot App</StoreHeading>
                    <StoreSub>You&rsquo;ll need the app to follow along.</StoreSub>
                    <StoreBadges>
                        <StoreLink href="https://apps.apple.com/app/id6482994081" target="_blank" rel="noopener noreferrer" aria-label="Download on the App Store">
                            <AppStoreBadge src={appStoreBadge} alt="Download on the App Store" />
                        </StoreLink>
                        <StoreLink href="https://play.google.com/store/apps/details?id=com.app.rhythmbot.android" target="_blank" rel="noopener noreferrer" aria-label="Get it on Google Play">
                            <GooglePlayBadge src={googlePlayBadge} alt="Get it on Google Play" />
                        </StoreLink>
                    </StoreBadges>
                </StoreSection>

                <DateBanner>
                    <h2>Begins July 1st.<br />Sign up by June 28th.</h2>
                </DateBanner>
            </NarrowWrapper>

            <Footer />

            <Modal open={signupComplete} onClick={goToRhythmBot}>
                <SuccessModalWrapper onClick={e => e.stopPropagation()}>
                    <SuccessModalBody>
                        <h2>You&rsquo;re all set!</h2>
                        <p>You&rsquo;ll receive the Day 1 links on July 1.</p>
                        <SuccessCTA teal pill large onClick={goToRhythmBot}>Get RhythmBot</SuccessCTA>
                    </SuccessModalBody>
                </SuccessModalWrapper>
            </Modal>
        </Page>
    );
};

export default SummerReadingChallenge;
